import React from 'react';
import CompMarquee from '../Components/CompMarquee';
import CompContentBlock from '../Components/CompContentBlock';
import './About.css'; // Import the CSS file
import { Grid } from '@mui/material';
import UXImgAboutFeature1 from '../Assets/Images/uxi-2025-about-feature1.png';
import UXImgAboutFeature2 from '../Assets/Images/uxi-2025-about-feature2.png';

function About() {
  return (
    <div className="about-container"> {/* Add a class to the container */}
      <CompMarquee title="About Us" subTitle="Learn more about our mission and values." />
      <CompContentBlock heading="Our Flow" subheading="User-centered innovation every single day.">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
            <img src={UXImgAboutFeature1} alt="Our Mission" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
            <h4>Center-out Strategically and Technically</h4>
            <p>
              A center-out strategy is core to our design process.  We start with the user and work our way out to the technology.  This ensures that our solutions are always user-centered and it's just common sense.  We also believe in the power of technology to drive UX insights.
            </p>
            </Grid>
            </Grid>
      </CompContentBlock>
      <CompContentBlock heading="Our Values" subheading="Innovation that is disruptive and creative.">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
            <img src={UXImgAboutFeature2} alt="Our Values" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
            <h4>Core Values</h4>
            <p>
              <strong>Actual impact.</strong><br />
              UX Integrity is not a "body shop" consulting firm floating from project to project.  Our goal is to make impactful solutions that our users would be frustrated living without.
            </p>
            <p>
              <strong>Shake up conventions.</strong><br />
              We believe that the best solutions come from challenging the status quo.  We're not afraid to take risks and push boundaries.
            </p>
            <p>
              <strong>World contributions.</strong><br />
              We love commercial projects as much as anyone, but we also believe in giving back.  We're always looking for ways to make the world a better place.
            </p>
            </Grid>
            </Grid>
      </CompContentBlock>
    </div>
  );
}

export default About;
